import React from 'react'
import { atlTheme } from '../atlTheme'
import { Platform } from 'react-native'
import { icons } from '../constants/searchAssets'
import { ATLButton, ButtonTypeEnum, TextCaseEnum } from '@appsimples/atlantica-react-native'

export const CustomHeader = (
  title: string,
  withHeaderLeft: boolean = true,
  onPressLeftButton: () => void = () => {},
  leftText?: string,
  withHeaderRight: boolean = false
) => {
  const customHeaderBasicNavigOptions = {
    headerTitle: title,
    headerTitleStyle: {
      fontFamily: atlTheme.FontFamilyBrand,
    },
    headerStyle: {
      height: Platform.OS === 'ios' ? 104 : 74,
      borderBottomWidth: 1,
      borderBottomColor: atlTheme.ColorBackground,
    },
    headerTintColor: atlTheme.ColorBrand1Default,
    headerTitleAlign: 'center' as 'center',
    headerLeft: null,
  }

  const customHeaderWithLeftNavigOptions = {
    ...customHeaderBasicNavigOptions,
    headerLeft: () => (
      <ATLButton
        type={ButtonTypeEnum.label}
        title={leftText || ''}
        horizontalMargin={-1}
        buttonBaseProps={{
          icon: icons.chevronLeft,
          iconSize: atlTheme.SizeIconBase,
          textCase: TextCaseEnum.none,
          textColorRegular: atlTheme.ColorBrand1Default,
        }}
        onPress={onPressLeftButton}
      />
    ),
  }

  const customHeaderWithLeftAndRightNavigOptions = {
    ...customHeaderWithLeftNavigOptions,
    headerRight: () => {},
  }

  if (withHeaderLeft && withHeaderRight) {
    return customHeaderWithLeftAndRightNavigOptions
  } else if (withHeaderLeft && !withHeaderRight) {
    return customHeaderWithLeftNavigOptions
  } else {
    return customHeaderBasicNavigOptions
  }
}
